module.exports = __webpack_public_path__ + "img/TCL.2f7b20ed.png";